import Axios from 'axios';
import { apiUrl } from 'app/environment-variables';
import { NavBarI, ParentType } from './models';

export const getNavBar = (parent: ParentType = 'null') =>
  Axios.get<CommonTypes.RestfulResponse<NavBarI>>(`${apiUrl}/nav-bar`, {
    params: { parent },
  });
